/**
 * Advertisement template definitions and constants
 */

export const ADVERTISEMENT_TEMPLATES = {
  discount_sale: {
    id: 'discount_sale',
    name: 'Discount Sale',
    description: 'Promote sales and special discounts',
    icon: 'LocalOffer',
    accentColor: '#FF5722',
    defaults: {
      badge: 'SALE',
      headline: 'Special Discount!',
      body: "Don't miss out on our exclusive offer.",
      ctaText: 'Shop Now'
    }
  },
  restock: {
    id: 'restock',
    name: 'Back in Stock',
    description: 'Notify when items are restocked',
    icon: 'Inventory',
    accentColor: '#4CAF50',
    defaults: {
      badge: 'BACK IN STOCK',
      headline: 'Item Restocked!',
      body: 'Popular items are back in stock.',
      ctaText: 'View Items'
    }
  },
  low_stock: {
    id: 'low_stock',
    name: 'Low Stock Alert',
    description: 'Create urgency for limited items',
    icon: 'Warning',
    accentColor: '#FFC107',
    defaults: {
      badge: 'LOW STOCK',
      headline: 'Limited Availability',
      body: 'Order soon before items run out.',
      ctaText: 'Order Now'
    }
  },
  announcement: {
    id: 'announcement',
    name: 'Announcement',
    description: 'Share news and updates',
    icon: 'Campaign',
    accentColor: '#2196F3',
    defaults: {
      badge: 'NEW',
      headline: 'Announcement',
      body: 'We have exciting news to share.',
      ctaText: 'Learn More'
    }
  },
  service_notice: {
    id: 'service_notice',
    name: 'Service Notice',
    description: 'Important service updates',
    icon: 'Info',
    accentColor: '#9C27B0',
    defaults: {
      badge: 'NOTICE',
      headline: 'Service Update',
      body: 'Important information about our services.',
      ctaText: 'Read More'
    }
  }
};

export const ADVERTISEMENT_STATUSES = {
  draft: { label: 'Draft', color: 'default' },
  active: { label: 'Active', color: 'success' },
  scheduled: { label: 'Scheduled', color: 'info' },
  expired: { label: 'Expired', color: 'warning' },
  disabled: { label: 'Disabled', color: 'error' }
};
